export * from './useProductDetailsNavigation';
